<template>
	<div>
		<checkout-v1></checkout-v1>
	</div>
</template>

<script>
export default {
	components: {
		"checkout-v1": () =>
			import(
				/* webpackChunkName: "v1" */
				"./components/v1/v1.vue"
			),
	},
}
</script>

<style lang="scss" scoped></style>
